import React, { useState, useMemo, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../utils/dateUtils';
import { createTruncatedTextForTable } from '../../../../utils/textUtils';

const WaybillShipmentTable = ({ data, totalRecords, isLoading, onPage, lazyParams, resetPagination = false }) => {
    const { th } = useLanguage();
    const safeParams = lazyParams || { page: 1, rows: 10 };

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const [currentFirst, setCurrentFirst] = useState(0);

    useEffect(() => {
        if (resetPagination) {
            setCurrentFirst(0);
            setSortField(null);
            setSortOrder(null);
        }
    }, [resetPagination]);

    const handlePage = (event) => {
        setCurrentFirst(event.first);
        onPage(event);
    };

    const onSort = (event) => {
        setSortField(event.sortField);
        setSortOrder(event.sortOrder);
    };

    const sortedData = useMemo(() => {
        console.log(data);
        if (!sortField || !data) return data;

        return [...data].sort((a, b) => {
            const aVal = a[sortField];
            const bVal = b[sortField];

            if (aVal === null || aVal === undefined) return 1;
            if (bVal === null || bVal === undefined) return -1;

            let comparison = 0;
            if (typeof aVal === 'string' && typeof bVal === 'string') {
                comparison = aVal.localeCompare(bVal, 'tr', { numeric: true });
            } else if (typeof aVal === 'number' && typeof bVal === 'number') {
                comparison = aVal - bVal;
            } else {
                comparison = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
            }

            return sortOrder * comparison;
        });
    }, [data, sortField, sortOrder]);


    return (
        <DataTable
            value={sortedData}
            paginator
            lazy
            first={currentFirst}
            rows={safeParams.rows}
            totalRecords={totalRecords}
            loading={isLoading}
            onPage={handlePage}
            onSort={onSort}
            sortField={sortField}
            sortOrder={sortOrder}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            dataKey="id"
            tableStyle={{ minWidth: '50rem' }}
            showGridlines
            stripedRows
            emptyMessage={th('parts.notFoundWaybillShipment')}
            removableSort
            sortMode="single"
        >
         <Column field="dataTime" header={th('parts.dataTime')} body={row => formatDateOnly(row.dataTime)} sortable />
    <Column field="waybillDate" header={th('parts.waybillDate')} body={row => formatDateOnly(row.waybillDate)} sortable />
    <Column field="eFaturaNo" header={th('parts.eFaturaNo')} sortable />
    <Column field="waybillNo" header={th('parts.waybillNo')} sortable />
    <Column field="salesCode" header={th('parts.salesCode')} sortable />
    <Column field="partName" header={th('parts.partName')} sortable />
    <Column field="quantity" header={th('parts.quantity')} sortable />
    <Column field="unitPrice" header={th('parts.unitPrice')} sortable />
    <Column field="amount" header={th('parts.amount')} sortable />
    <Column field="pb" header={th('parts.pb')} sortable />
    <Column field="orderNo" header={th('parts.orderNo')} sortable />
    <Column field="dealerOrderNo" header={th('parts.dealerOrderNo')} sortable />
    <Column field="orderPriority" header={th('parts.orderPriority')} sortable />
    <Column field="exitWarehouse" header={th('parts.exitWarehouse')} sortable />
    <Column field="shippingAddressId" header={th('parts.shippingAddressId')} sortable />
    <Column field="dealerSiteId" header={th('parts.dealerSiteId')} sortable />
    <Column field="dealerNo" header={th('parts.dealerNo')} sortable />
    <Column field="orderType" header={th('parts.orderType')} sortable />
                            <Column field="dealerName" header={th('parts.dealerName')} sortable body={(rowData) => createTruncatedTextForTable(rowData.dealerName, 40)} />
    <Column field="systemInvoicesNo" header={th('parts.systemInvoicesNo')} sortable />
        </DataTable>
    );
};

export default WaybillShipmentTable;
